import Vue from 'vue'

import date from './date'
// I really don't know why, but would crash with ESlint only for this one so disabled for this line
// eslint-disable-next-line
import datetime from './datetime'
import ellipsis from './ellipsis'
import fixed from './fixed'
import locale from './locale'
import locales from './locales'
import percentage from './percentage'
import time from './time'
import timelapse from './timelapse'

Vue.filter('date', date)
Vue.filter('datetime', datetime)
Vue.filter('ellipsis', ellipsis)
Vue.filter('fixed', fixed)
Vue.filter('locale', locale)
Vue.filter('locales', locales)
Vue.filter('percentage', percentage)
Vue.filter('time', time)
Vue.filter('timelapse', timelapse)
